import React, { Component } from "react";

import "./Container.css";

export default class Container extends Component {
  render() {
    let { chatSize, resize: { active = false, resizeHeight = null, resizeWidth = null } = {}, } = window["boot"];
   
    return (
      <div
        className={`base-container ${!active && chatSize}`}
        style={{
          ...(active && {
            height: "100%",
            width: resizeWidth,
          }),
          ...(resizeHeight < "25rem" || resizeHeight < "400px" && {
            overflow: "auto",
          })
        }}
      >
        {this.props.children}
      </div>
    );
  }
}
